/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeRepairConfigCreatedResponse,
  ApiEnvelopeRepairConfigListResponse,
  ApiEnvelopeRepairEmptyResponse,
  ApiEnvelopeRepairRunResponse,
  RepairConfigInputDto,
  RepairStopRepairParams,
  RunRepairRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type repairGetRepairConfigsResponse200 = {
  data: ApiEnvelopeRepairConfigListResponse
  status: 200
}

export type repairGetRepairConfigsResponseSuccess = (repairGetRepairConfigsResponse200) & {
  headers: Headers;
};
;

export type repairGetRepairConfigsResponse = (repairGetRepairConfigsResponseSuccess)

export const getRepairGetRepairConfigsUrl = () => {




  return `/api/Repair`
}

export const useRepairGetRepairConfigsHook = (): ( options?: RequestInit) => Promise<repairGetRepairConfigsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getRepairGetRepairConfigsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type repairCreateRepairConfigResponse200 = {
  data: ApiEnvelopeRepairConfigCreatedResponse
  status: 200
}

export type repairCreateRepairConfigResponse400 = {
  data: ApiEnvelopeRepairConfigCreatedResponse
  status: 400
}

export type repairCreateRepairConfigResponseSuccess = (repairCreateRepairConfigResponse200) & {
  headers: Headers;
};
export type repairCreateRepairConfigResponseError = (repairCreateRepairConfigResponse400) & {
  headers: Headers;
};

export type repairCreateRepairConfigResponse = (repairCreateRepairConfigResponseSuccess | repairCreateRepairConfigResponseError)

export const getRepairCreateRepairConfigUrl = () => {




  return `/api/Repair`
}

export const useRepairCreateRepairConfigHook = (): (repairConfigInputDto?: RepairConfigInputDto, options?: RequestInit) => Promise<repairCreateRepairConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (repairConfigInputDto?: RepairConfigInputDto, options?: RequestInit) => {

        return customFetcher(getRepairCreateRepairConfigUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(repairConfigInputDto)
  }
);
      }
  }


export type repairUpdateRepairConfigResponse200 = {
  data: ApiEnvelopeRepairEmptyResponse
  status: 200
}

export type repairUpdateRepairConfigResponse400 = {
  data: ApiEnvelopeRepairEmptyResponse
  status: 400
}

export type repairUpdateRepairConfigResponse404 = {
  data: ApiEnvelopeRepairEmptyResponse
  status: 404
}

export type repairUpdateRepairConfigResponseSuccess = (repairUpdateRepairConfigResponse200) & {
  headers: Headers;
};
export type repairUpdateRepairConfigResponseError = (repairUpdateRepairConfigResponse400 | repairUpdateRepairConfigResponse404) & {
  headers: Headers;
};

export type repairUpdateRepairConfigResponse = (repairUpdateRepairConfigResponseSuccess | repairUpdateRepairConfigResponseError)

export const getRepairUpdateRepairConfigUrl = (id: string,) => {




  return `/api/Repair/${id}`
}

export const useRepairUpdateRepairConfigHook = (): (id: string,
    repairConfigInputDto?: RepairConfigInputDto, options?: RequestInit) => Promise<repairUpdateRepairConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    repairConfigInputDto?: RepairConfigInputDto, options?: RequestInit) => {

        return customFetcher(getRepairUpdateRepairConfigUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(repairConfigInputDto)
  }
);
      }
  }


export type repairDeleteRepairConfigResponse200 = {
  data: ApiEnvelopeRepairEmptyResponse
  status: 200
}

export type repairDeleteRepairConfigResponse404 = {
  data: ApiEnvelopeRepairEmptyResponse
  status: 404
}

export type repairDeleteRepairConfigResponseSuccess = (repairDeleteRepairConfigResponse200) & {
  headers: Headers;
};
export type repairDeleteRepairConfigResponseError = (repairDeleteRepairConfigResponse404) & {
  headers: Headers;
};

export type repairDeleteRepairConfigResponse = (repairDeleteRepairConfigResponseSuccess | repairDeleteRepairConfigResponseError)

export const getRepairDeleteRepairConfigUrl = (id: string,) => {




  return `/api/Repair/${id}`
}

export const useRepairDeleteRepairConfigHook = (): (id: string, options?: RequestInit) => Promise<repairDeleteRepairConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getRepairDeleteRepairConfigUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type repairRunRepairConfigResponse200 = {
  data: ApiEnvelopeRepairRunResponse
  status: 200
}

export type repairRunRepairConfigResponse400 = {
  data: ApiEnvelopeRepairRunResponse
  status: 400
}

export type repairRunRepairConfigResponse404 = {
  data: ApiEnvelopeRepairRunResponse
  status: 404
}

export type repairRunRepairConfigResponseSuccess = (repairRunRepairConfigResponse200) & {
  headers: Headers;
};
export type repairRunRepairConfigResponseError = (repairRunRepairConfigResponse400 | repairRunRepairConfigResponse404) & {
  headers: Headers;
};

export type repairRunRepairConfigResponse = (repairRunRepairConfigResponseSuccess | repairRunRepairConfigResponseError)

export const getRepairRunRepairConfigUrl = (id: string,) => {




  return `/api/Repair/${id}/run`
}

export const useRepairRunRepairConfigHook = (): (id: string,
    runRepairRequest?: RunRepairRequest, options?: RequestInit) => Promise<repairRunRepairConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    runRepairRequest?: RunRepairRequest, options?: RequestInit) => {

        return customFetcher(getRepairRunRepairConfigUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(runRepairRequest)
  }
);
      }
  }


export type repairStopRepairResponse200 = {
  data: ApiEnvelopeRepairEmptyResponse
  status: 200
}

export type repairStopRepairResponse404 = {
  data: ApiEnvelopeRepairEmptyResponse
  status: 404
}

export type repairStopRepairResponseSuccess = (repairStopRepairResponse200) & {
  headers: Headers;
};
export type repairStopRepairResponseError = (repairStopRepairResponse404) & {
  headers: Headers;
};

export type repairStopRepairResponse = (repairStopRepairResponseSuccess | repairStopRepairResponseError)

export const getRepairStopRepairUrl = (id: string,
    params?: RepairStopRepairParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Repair/${id}/stop?${stringifiedParams}` : `/api/Repair/${id}/stop`
}

export const useRepairStopRepairHook = (): (id: string,
    params?: RepairStopRepairParams, options?: RequestInit) => Promise<repairStopRepairResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    params?: RepairStopRepairParams, options?: RequestInit) => {

        return customFetcher(getRepairStopRepairUrl(id,params),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


